// extracted by mini-css-extract-plugin
export default {"buttons":"ChangeLogs_buttons__HK+uW"};